module.exports = __webpack_public_path__ + "static/molecular-gastronomy-0abaa9561e17ef62792740de2538dba4.jpg";